import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=36f38db0&"
import script from "./Report.vue?vue&type=script&lang=js&"
export * from "./Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports